export default __webpack_public_path__ + "static/media/18.26449d71.png";